/** Pediatric dose calculator */

export function calcPediatricDose({ drug, weightKg, ageYears }) {
  const w = Number(weightKg);
  if (!w || w <= 0) return { error: 'Enter valid weight in kg' };

  const rules = {
    paracetamol: { mgPerKg: 15, maxMg: 650, unit: 'mg', freq: 'QID', form: 'Paracetamol' },
    ibuprofen: { mgPerKg: 10, maxMg: 400, unit: 'mg', freq: 'TID', form: 'Ibuprofen' },
    amoxicillin: { mgPerKg: 25, maxMg: 500, unit: 'mg', freq: 'TID', form: 'Amoxicillin' },
    azithromycin: { mgPerKg: 10, maxMg: 500, unit: 'mg', freq: 'OD', form: 'Azithromycin' },
  };

  const key = (drug || 'paracetamol').toLowerCase().replace(/\s/g, '');
  const rule = rules[key] || rules.paracetamol;
  const doseMg = Math.min(Math.round(w * rule.mgPerKg), rule.maxMg);
  const ageNote = ageYears ? ` (age ${ageYears}y)` : '';

  return {
    drug: rule.form,
    dose: `${doseMg} ${rule.unit}`,
    frequency: rule.freq,
    note: `Weight ${w} kg${ageNote} · ${rule.mgPerKg} mg/kg (max ${rule.maxMg} mg)`,
    rxLine: `${rule.form} ${doseMg}mg ${rule.freq} — ${w}kg patient`,
  };
}
